'use strict';

/**
 * View for empty scanners lists
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var template = require('modules/collection/templates/partials/list-scanners-empty.hbs');

var EmptyView = ItemView.extend({
    template: template,

    className: 'empty-hint',
});

module.exports = EmptyView;